import { GetActivoByIdDtoProps } from "./DTOs/GetActivoByIdDto"
import { GetActivosByFiltersDtoProps } from "./DTOs/GetActivosByFiltersDto"
import { GetAmortizacionesDtoPropsProps } from "./DTOs/GetAmortizacionesDto"
import { GetDetalleAmortizacionActivoByIdDtoProps } from "./DTOs/GetDetalleAmortizacionActivoByIdDto"

export function activosByFiltersAdapter(
  activo: GetActivosByFiltersDtoProps
): GetActivosByFiltersDtoProps {
  return {
    id: activo.id,
    amortizado: activo.amortizado,
    cuentaContable: {
      id: activo.cuentaContable?.id,
      numero: activo.cuentaContable?.numero,
    },
    estado: activo.estado,
    fechaAdquisicion: activo.fechaAdquisicion,
    identificador: activo.identificador,
    importe: activo.importe,
    nombre: activo.nombre,
    valorNeto: activo.valorNeto,
  }
}

export function activoByIdAdapter(
  activo: GetActivoByIdDtoProps
): GetActivoByIdDtoProps {
  return {
    id: activo.id,
    codigoBarras: activo.codigoBarras,
    descripcion: activo.descripcion,
    esAmortizable: activo.esAmortizable,
    estado: activo.estado,
    facturaId: activo.facturaId,
    fechaAdquisicion: activo.fechaAdquisicion,
    marca: activo.marca,
    modelo: activo.modelo,
    nombre: activo.nombre,
    numeroCuentaContable: activo.numeroCuentaContable,
    numeroCuentaContableContrapartida: activo.numeroCuentaContableContrapartida,
    numeroFactura: activo.numeroFactura,
    numeroInventario: activo.numeroInventario,
    numeroSerie: activo.numeroSerie,
    proveedor: activo.proveedor,
    resumenAmortizacion: activo.resumenAmortizacion,
    tipoCreacion: activo.tipoCreacion,
    tipoInmovilizado: activo.tipoInmovilizado,
  }
}

export function activoDetalleAmortizacionByIdAdapter(
  amortizacion: GetDetalleAmortizacionActivoByIdDtoProps
): GetDetalleAmortizacionActivoByIdDtoProps {
  return {
    id: amortizacion.id,
    anyos: amortizacion.anyos,
    coeficienteAmortizacion: amortizacion.coeficienteAmortizacion,
    concepto: amortizacion.concepto,
    cuentaContableAcumulada: amortizacion.cuentaContableAcumulada,
    cuentaContableGasto: amortizacion.cuentaContableGasto,
    tipo: amortizacion.tipo,
    tipoPeriodo: amortizacion.tipoPeriodo,
  }
}

export function activoAmortizacionesAdapter(
  amortizacion: GetAmortizacionesDtoPropsProps
): GetAmortizacionesDtoPropsProps {
  return {
    id: amortizacion.id,
    amortizacionAcumulada: amortizacion.amortizacionAcumulada,
    asientoId: amortizacion.asientoId,
    cuotaAmortizacion: amortizacion.cuotaAmortizacion,
    fechaUltimaAmortizacion: amortizacion.fechaUltimaAmortizacion,
    valorNetoActual: amortizacion.valorNetoActual,
  }
}
